/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { Collapse, Typography } from '@material-ui/core';
import ListItem from './listItem';
// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles((theme) => ({
  listroot: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  sectionheader: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: 12,

    '&:hover': {
      backgroundColor: 'rgba(38, 187, 237, 0.06)',
      cursor: 'pointer',
    },

    '&:hover $listitemcount': {
      backgroundColor: '#fff',
    },
  },
  chevrons: {
    padding: 4,
    width: '1.5em',
    height: '1.5em',
    fontSize: 24,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  headertitle: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '24px',
    color: '#000000',
  },
  listitemcount: {
    width: 60,
    // backgroundColor: 'red',
    textAlign: 'center',
    height: 24,
    fontSize: 12,
    lineHeight: '18px',
    color: '#000000',
    backgroundColor: '#f9f9f9',
    padding: '2px 4px',
    marginLeft: 8,
    borderRadius: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const EventList = React.memo(({
  monthYear,
  events,
  onPrimaryActionClickedCallback,
  onEditClickedCallback,
  onDuplicateClickedCallback,
  onPreviewClickedCallback,
  onArchiveClickedCallback,
  onCancelClickedCallback,
  onRSVPClickedCallback,
  onPublishClickedCallback,
  onScheduleInviteClickedCallback,
  onUnarchiveCallback,
  onRescheduleClickedCallback,
  disabled
}) => {
  const classes = useStyles();
  const [openList, setOpenList] = useState(true);

  const openCloseList = () => {
    setOpenList(!openList);
  };



  return (
    <div className={classes.listroot}>
      <div className={classes.sectionheader} onClick={openCloseList}>
        {openList ? (
          <ArrowDropDownIcon
            className={classes.chevrons}
            onClick={openCloseList}
          />
        ) : (
          <ArrowRightIcon
            onClick={openCloseList}
            className={classes.chevrons}
          />
        )}
        <Typography variant='h6' className={classes.headertitle}>
          {monthYear}
        </Typography>
        {/* <Typography
          variant='h6'
          className={`${classes.listitemcount} eventcount-22`}
        >
          {events.length} events
        </Typography> */}
      </div>
      <Collapse in={openList} timeout='auto' unmountOnExit>
        {events.map((item, key) => (
          <ListItem
            key={item.id}
            id={item.id}
            eventItem={item}
            weekday={item.weekday}
            startTime={item.startTime}
            endTime={item.endTime}
            eventTitle={item.eventTitle}
            status={item.status}
            recurringEventType={item.recurringEventType}
            totalGuests={item.totalGuests}
            confirmedGuests={item.confirmedGuests}
            btnText={item.btnText}
            onPrimaryActionClickedCallback={onPrimaryActionClickedCallback}
            onEditClickedCallback={onEditClickedCallback}
            onDuplicateClickedCallback={onDuplicateClickedCallback}
            onPreviewClickedCallback={onPreviewClickedCallback}
            onArchiveClickedCallback={onArchiveClickedCallback}
            onCancelClickedCallback={onCancelClickedCallback}
            onRSVPClickedCallback={onRSVPClickedCallback}
            onPublishClickedCallback={onPublishClickedCallback}
            onRescheduleClickedCallback={onRescheduleClickedCallback}
            onScheduleInviteClickedCallback={onScheduleInviteClickedCallback}
            onUnarchiveCallback={onUnarchiveCallback}
            disabled={disabled}
            upcoming={item.upcoming}
          />
        ))}
      </Collapse>
    </div>
  );
});

EventList.propTypes = {
  /*
  Month Year format string Feb 2020 for
  */
  monthYear: PropTypes.string,
  /**
  array of events object . object attributes should be same as in the example
  */
  events: PropTypes.array,
  /*
  Primary button clicked Callback available at each list item .
  */
  onPrimaryActionClickedCallback: PropTypes.func,
  /*
  Menu Item Edit clicked Callback
  */
  onEditClickedCallback: PropTypes.func,
  /*
  Menu Item Duplicate clicked Callback
  */
  onDuplicateClickedCallback: PropTypes.func,
  /*
  Menu Item Preview clicked Callback
  */
  onPreviewClickedCallback: PropTypes.func,
  /*
  Menu Item Preview clicked Callback
  */
  onArchiveClickedCallback: PropTypes.func,
  /*
  Menu Item Cancel clicked Callback
  */
  onCancelClickedCallback: PropTypes.func,
  /*
  RSVPs clicked Callback
  */
  onRSVPClickedCallback: PropTypes.func,
  /*
  Menu Item Publish clicked Callback
  */
  onPublishClickedCallback: PropTypes.func,
  /*
  Menu Item Schedule Invite clicked Callback
  */
  onScheduleInviteClickedCallback: PropTypes.func
};

EventList.defaultProps = {
  monthYear: 'Feb 2020',
  events: [],
  onPrimaryActionClickedCallback: undefined,
  onEditClickedCallback: undefined,
  onDuplicateClickedCallback: undefined,
  onPreviewClickedCallback: undefined,
  onArchiveClickedCallback: undefined,
  onCancelClickedCallback: undefined,
  onRSVPClickedCallback: undefined,
  onPublishClickedCallback: undefined,
  onScheduleInviteClickedCallback: undefined,
};

export default EventList;

//arrow sign
// in cancel disable btn
// button color changes on hover
